import React from 'react';
import { useInboundAcceptance } from '@contexts/operator/InboundAcceptanceContext';
import { Modal, List, Button, Avatar, Space, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

const { Text } = Typography;

export default function ProductSelectionModal() {
  const { productCandidates, selectProduct, setProductCandidates } = useInboundAcceptance();
  const { t } = useTranslation();

  const handleCancel = () => {
    setProductCandidates(null);
  };

  const handleSelect = (product) => {
    selectProduct(product);
  };

  if (!productCandidates) return null;

  return (
    <Modal
      title={t('operator.select_product', { defaultValue: '請選擇商品' })}
      open={!!productCandidates}
      onCancel={handleCancel}
      footer={null}
      destroyOnClose
      width={600}
    >
      <List
        itemLayout="horizontal"
        dataSource={productCandidates}
        renderItem={(item) => (
          <List.Item
            actions={[
              <Button type="primary" size="small" onClick={() => handleSelect(item)}>
                {t('common.select', { defaultValue: '選擇' })}
              </Button>
            ]}
          >
            <List.Item.Meta
              avatar={
                <Avatar 
                  src={item.public_photo_url || item.image_url} 
                  shape="square" 
                  size={64} 
                  style={{ backgroundColor: '#f0f0f0' }}
                >
                  {!item.public_photo_url && item.name?.charAt(0)}
                </Avatar>
              }
              title={<Text strong>{item.name}</Text>}
              description={
                <Space direction="vertical" size={0} style={{ width: '100%' }}>
                  <Text type="secondary" style={{ fontSize: 12 }}>SKU: <Text code>{item.sku}</Text></Text>
                  {item.barcode && <Text type="secondary" style={{ fontSize: 12 }}>Barcode: <Text code>{item.barcode}</Text></Text>}
                </Space>
              }
            />
          </List.Item>
        )}
      />
    </Modal>
  );
}
